import Script from "next/script";


declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement: (element: Element, force?: boolean) => void;
    };
  }
}


export function TrustpilotScript() {
  return (
    <Script
      async
      src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
      type="text/javascript"
      strategy="lazyOnload"
    />
  );
}
